import 'uuid';
import { writable } from 'svelte/store';
const GameStore = writable({
    username: null,
    score: 0,
    elapsedTime: 0,
    world: null,
    boosts: 3,
    jumps: 4,
    winnerName: null,
    game: null,
});
export default GameStore;
